import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { FILTER_SITES } from "../../constants/filter-types";
import { useLocale } from "../../contexts/localeContext";
import { TableContextProvider } from "../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import columns from '../../models/ColumnDefinitions/SiteColumns';
import searchColumns from '../../models/search/SiteSearch';
import { getLoginById } from "../../services/loginService";
import { getSites } from "../../services/siteService";
import { getErrorMessage } from "../../services/utilities/ServiceError";
import TableTab from "../tabs/table-tab";
interface WizardContentFormProps {
    onNext: (event: any) => void;
    onBack: (event: any) => void;
}

export const WizardContentForm: FC<WizardContentFormProps> = ({ onBack, onNext }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.sites);
    const [selectedIds, setSelectedIds] = useState<string[]>(values.id && values.settingDatas ? values.settingDatas : []);
    const [alwaysSelectedAndDisabled, setAlwaysSelectedAndDisabled] = useState<string[]>([]);

    useEffect(() => {
        getLoginById(values.userLoginId).then((user: any) => {
            setAlwaysSelectedAndDisabled([user.siteId])
        }).catch((error) => {
            toast.warn(getErrorMessage(error));
            onBack(new MouseEvent('click'))
        })
    }, [])

    const refreshTableDataForSelectedOption = () => {
        if (values.type === FILTER_SITES) {
            return <TableContextProvider
                useFilter
                usePagination
                useTable
                useSort
                useSearch
                dataMethod={getSites}
                tableDescriptor={columns}
                searchDescriptor={searchColumns}
                alwaysSelectedAndDisabled={alwaysSelectedAndDisabled}
                canExportReport={false}>
                <TableTab
                    title={title}
                    selectRows={true}
                    selectedIds={selectedIds}
                    setSelectedIds={setSelectedIds}
                    cyName="wizardContent"/>
            </TableContextProvider>
        }
    }

    const handleNext = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if ([...selectedIds, ...alwaysSelectedAndDisabled].length > 0) {
            setFieldValue('settingDatas', [...selectedIds, ...alwaysSelectedAndDisabled]);
            onNext({ ...e, itemName: (selectedIds.length + " " + translate.byKey(TranslationKeys.selected)), filterItem: values })
        }
    }

    return <div className="pt-3 pr-3 h-full">
        <div className="overflow-y-auto" style={{ height: '87%' }}>{refreshTableDataForSelectedOption()}</div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5`}
                    type="button"
                    onClick={onBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary ${[...selectedIds, ...alwaysSelectedAndDisabled].length > 0 ? 'secondary-enabled' : 'secondary-disabled cursor-not-allowed' }`}
                    type='button'
                    id="wizardContentNextBtn"
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
};


